function mentaScrollTo(selector) {
  var el = document.querySelector(selector);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}

function toggleMobileMenu() {
  var menu = document.getElementById('mobile-menu');
  if (menu) {
    menu.classList.toggle('is-open');
  }
}

function openServiceModal(id) {
  var modal = document.getElementById('modal-' + id);
  if (modal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
}

function closeServiceModal(id) {
  var modal = document.getElementById('modal-' + id);
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var modals = document.querySelectorAll('.menta-modal');
    modals.forEach(function(modal) {
      modal.style.display = 'none';
    });
    document.body.style.overflow = '';
  }
});
